var path = 'receipts/receiptsContent.tpl.html';
var html = "<div class=\"{{animationCls}} sbsf-receipts-details-ctr row\" ui-view=\"receiptsDetails\" autoscroll=\"false\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;